// extracted by mini-css-extract-plugin
export default {"sort-direction-icon":"DataTable_sort-direction-icon__bFb7c"};